<template>
  <div
    class="bottom-btn-bg glass"
    :class="{
      'bottom-btn-normal-bg': canVote,
      'bottom-btn-disable-bg': !canVote,
    }"
  ></div>
  <van-button
    :loading="voteLoading"
    loading-text="投票中..."
    block
    icon="records"
    :disabled="!canVote"
    type="primary"
    color="#008cd6"
    @click="vote"
    :class="canVote ? 'vote-btn button glass' : 'vote-btn'"
    >投票
    <span
      >(今天剩余可选作品数:{{ voteNum === 0 ? voteNum : leftVoteNum }})</span
    >
  </van-button>
</template>

<script>
import { Button } from "vant";
import { computed } from "vue";
import { useStore } from "vuex";
// import { useRoute } from "vue-router";
export default {
  name: "VoteBtn",
  components: {
    [Button.name]: Button,
  },
  setup() {
    const store = useStore();
    // const route = useRoute();

    const vote = () => {
      console.log("6有没有id", store.state.termId);
      let id = store.state.termId;
      store.dispatch("multyVote", id);
    };

    return {
      voteLoading: computed(() => store.state.voteLoading),
      vote,
      leftVoteNum: computed(() => store.state.leftVoteNum),
      voteNum: computed(() => store.state.voteNum),
      // canVote,
      canVote: computed(
        () =>
          store.state.countDown > 0 &&
          store.state.selectedVoteNum > 0 &&
          store.state.canVote
      ),
      // canVote: computed(() => {
      //   const sum =
      //     store.state.candidates.length > 0
      //       ? store.state.candidates.reduce((a, b) => a.my_vote + b.my_vote)
      //       : 0;
      //   return store.state.countDown > 0 && sum > 0;
      // }),
    };
  },
};
</script>

<style lang="scss" scoped>
.bottom-btn-normal-bg {
  // background-color: var(--van-button-primary-background-color);
  background-color: #008cd6;
}

.bottom-btn-disable-bg {
  // background-color: var(--van-button-primary-background-color);
  background-color: #008cd6;
  opacity: var(--van-button-disabled-opacity);
}

.bottom-btn-bg {
  position: absolute;
  top: var(--van-button-default-height);
  left: 0;
  // background-color: var(--van-button-primary-background-color);
  background-color: #008cd6;
  width: 100%;
  height: env(safe-area-inset-bottom);
}

.button.glass {
  position: relative;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    animation: glass 1.5s infinite;
    background: left / auto 100% no-repeat url("../assets/img/gif_button.png");
  }
  @keyframes glass {
    0% {
      left: 0;
    }
    50% {
      left: 100%;
      opacity: 0;
    }
    100% {
      left: 100%;
      opacity: 0;
    }
  }
}
</style>
